'use client';
import React, { useState, useMemo, useCallback } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useShowSetting } from '@/src/components//context/ShowSettingProvider.jsx';
import Link from 'next/link';
import ReactHtmlParser from 'react-html-parser';
import FormContact from '@/src/components/common/form/FormContact.jsx';
import getFormData from '@/public/json/forms.json';
import CloseButtonYgen from '@/src/components/common/ui/buttons/CloseButtonYgen.jsx';
import Title from '@/src/components/common/ui/text/Title.jsx';
import Social from '@/src/components/common/ui/social/Social.jsx';
import { StyledContactForm } from '@/src/components/common/eco/sections/contact-form/contact-form.style.js';
import ReactPlayer from 'react-player';
import VideoPlayer from '@/src/components/common/eco/sections/banner/VideoPlayer.jsx';

const ContactForm = ({ data, form_id, interest, asModal, onclick, show, career, topTitle, bottomTitle }) => {
	const settingData = useShowSetting();
	const getSettingData = settingData?.getSettings;
	const [formData] = useState(getFormData);


	const resolvedFormId = useMemo(() =>
			form_id || data?.section_data?.form_id || 'contact_form',
		[form_id, data?.section_data?.form_id]
	);

	const resolvedFormData = useMemo(() =>
			formData?.[resolvedFormId] || formData?.contact_form,
		[formData, resolvedFormId]
	);

	const backgroundStyle = useMemo(() => ({
		background: data?.section_data?.description || 'white'
	}), [data?.section_data?.description]);

	const handleClick = useCallback(() => {
		if (onclick) {
			onclick();
		}
	}, [onclick]);

	// Memoize contact information
	const contactInfo = useMemo(() => ({
		phone: getSettingData?.office_phone,
		email: getSettingData?.contact_email,
		location: getSettingData?.office_location,
		mapLink: getSettingData?.google_map_link,
		facebook: getSettingData?.facebook,
		youtube: getSettingData?.youtube,
		linkedin: getSettingData?.linkedin,
		instagram: getSettingData?.instagram
	}), [getSettingData]);


	const officePhones = contactInfo?.phone?.split(',') || [];



	return (
		<StyledContactForm
			style={backgroundStyle}
			className={`ContactForm ${asModal ? 'asModal' : ''}`}

		>
			{asModal && (
				<div className="close-button-ygen" onClick={handleClick}>
					<CloseButtonYgen active={show} color="#152637" />
				</div>
			)}
			<video preload poster={'/images/static/contactus.jpg'} src={'/images/contact.mp4'} autoPlay muted loop playsInline />



			<Container>
				<Row className={'contact-row'}>
					<Col md={asModal ? 7 : 4}>

						<Title
							tag={'h2'}
							margin={'0 0 180px'}
							text={data?.section_data?.subtitle}
							color={'#fff'}
						/>

						{asModal ? (
							<div className="job-conetent">
								<Title
									tag="h3"
									text={data?.title}
									color="#152637"
									margin="0 0 60px"
								/>
								{data?.description && ReactHtmlParser(data?.description)}
							</div>
						) : (
							<div className="d-flex">
								<div className="single-item fade-up">
									<div className="icon">
										<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M10.0004 6.99999C10.0004 7.79564 9.68436 8.55871 9.12176 9.12131C8.55915 9.68392 7.79608 9.99999 7.00043 9.99999C6.20478 9.99999 5.44172 9.68392 4.87911 9.12131C4.3165 8.55871 4.00043 7.79564 4.00043 6.99999C4.00043 6.20434 4.3165 5.44128 4.87911 4.87867C5.44172 4.31606 6.20478 3.99999 7.00043 3.99999C7.79608 3.99999 8.55915 4.31606 9.12176 4.87867C9.68436 5.44128 10.0004 6.20434 10.0004 6.99999ZM9.00043 6.99999C9.00043 6.46956 8.78972 5.96085 8.41465 5.58578C8.03958 5.21071 7.53087 4.99999 7.00043 4.99999C6.47 4.99999 5.96129 5.21071 5.58622 5.58578C5.21115 5.96085 5.00043 6.46956 5.00043 6.99999C5.00043 7.53043 5.21115 8.03913 5.58622 8.41421C5.96129 8.78928 6.47 8.99999 7.00043 8.99999C7.53087 8.99999 8.03958 8.78928 8.41465 8.41421C8.78972 8.03913 9.00043 7.53043 9.00043 6.99999ZM11.9504 11.955C13.2633 10.6414 14.0009 8.86021 14.0009 7.00299C14.0009 5.14578 13.2633 3.36458 11.9504 2.05099C11.3004 1.40091 10.5287 0.885227 9.67938 0.5334C8.83006 0.181572 7.91975 0.000488281 7.00043 0.000488281C6.08112 0.000488281 5.17081 0.181572 4.32149 0.5334C3.47216 0.885227 2.70045 1.40091 2.05043 2.05099C0.737527 3.36458 0 5.14578 0 7.00299C0 8.86021 0.737527 10.6414 2.05043 11.955L3.57143 13.454L5.61443 15.439L5.74743 15.557C6.52243 16.185 7.65743 16.145 8.38743 15.439L10.8224 13.069L11.9504 11.955ZM2.75543 2.75599C3.31267 2.19813 3.9744 1.75558 4.70279 1.45363C5.43118 1.15169 6.21194 0.996273 7.00043 0.996273C7.78893 0.996273 8.56969 1.15169 9.29808 1.45363C10.0265 1.75558 10.6882 2.19813 11.2454 2.75599C12.3397 3.85169 12.9688 5.32747 13.0016 6.87566C13.0344 8.42385 12.4683 9.92495 11.4214 11.066L11.2454 11.25L9.92443 12.554L7.69443 14.723L7.60043 14.803C7.42723 14.9327 7.21664 15.0027 7.00027 15.0025C6.7839 15.0023 6.57342 14.932 6.40043 14.802L6.30743 14.722L3.32743 11.817L2.75543 11.25L2.57943 11.067C1.53254 9.92595 0.966485 8.42485 0.999275 6.87666C1.03206 5.32847 1.66117 3.85169 2.75543 2.75599Z"
												fill="white" />
										</svg>
									</div>
									<div className="content">
										<Link target="_blank" href={contactInfo.mapLink || '/'}>
											{ReactHtmlParser(contactInfo.location)}
										</Link>
									</div>
								</div>

								<div className="single-item fade-up">
									<div className="icon">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M14.93 16C13.2447 16 11.5167 15.578 9.746 14.734C7.97533 13.89 6.33033 12.705 4.811 11.179C3.29167 9.653 2.11 8.008 1.266 6.244C0.422 4.48 0 2.75533 0 1.07C0 0.764667 0.1 0.510333 0.3 0.307C0.5 0.103667 0.75 0.00133333 1.05 0H3.523C3.795 0 4.03233 0.0856666 4.235 0.257C4.43767 0.428333 4.57467 0.648 4.646 0.916L5.142 3.3C5.18867 3.58 5.18033 3.82433 5.117 4.033C5.05367 4.24167 4.94267 4.41267 4.784 4.546L2.59 6.592C3.00067 7.33667 3.45433 8.02867 3.951 8.668C4.44767 9.30733 4.97767 9.913 5.541 10.485C6.121 11.065 6.74567 11.605 7.415 12.105C8.08433 12.6043 8.819 13.0757 9.619 13.519L11.758 11.342C11.9207 11.1667 12.1037 11.051 12.307 10.995C12.5097 10.9397 12.7343 10.9287 12.981 10.962L15.084 11.392C15.356 11.4587 15.5767 11.5957 15.746 11.803C15.9153 12.0103 16 12.2477 16 12.515V14.95C16 15.25 15.898 15.5 15.694 15.7C15.49 15.9 15.2347 16 14.93 16ZM2.12 5.654L4.04 3.889C4.10333 3.83767 4.14467 3.767 4.164 3.677C4.184 3.587 4.18067 3.50367 4.154 3.427L3.711 1.307C3.685 1.205 3.64 1.12833 3.576 1.077C3.512 1.02567 3.429 1 3.327 1H1.275C1.19833 1 1.13433 1.02567 1.083 1.077C1.03167 1.12833 1.006 1.19233 1.006 1.269C1.02533 1.95233 1.13233 2.66567 1.327 3.409C1.52167 4.15233 1.78533 4.90067 2.12 5.654ZM10.571 13.988C11.247 14.3227 11.967 14.5703 12.731 14.731C13.4963 14.891 14.163 14.9767 14.731 14.988C14.8077 14.988 14.8717 14.9623 14.923 14.911C14.9743 14.8597 15 14.796 15 14.72V12.712C15 12.61 14.9743 12.5267 14.923 12.462C14.8717 12.398 14.795 12.3533 14.693 12.328L12.843 11.949C12.7657 11.923 12.698 11.9197 12.64 11.939C12.5827 11.959 12.522 12.0007 12.458 12.064L10.571 13.988Z"
												fill="white" />
										</svg>

									</div>
									<div className="content">
										{officePhones.map((phone, index) => (
											<React.Fragment key={index}>
												<Link href={`tel:${phone}`}>
													{ReactHtmlParser(phone)}
												</Link>
												{index !== officePhones.length - 1 && ', '}
											</React.Fragment>
										))}

									</div>
								</div>
								<div className="single-item fade-up">
									<div className="icon">
										<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M17.4354 0.0649414H2.56543C1.90239 0.0649414 1.2665 0.328333 0.797663 0.797174C0.328822 1.26602 0.0654297 1.9019 0.0654297 2.56494V13.4349C0.0654297 14.098 0.328822 14.7339 0.797663 15.2027C1.2665 15.6715 1.90239 15.9349 2.56543 15.9349H17.4354C18.0985 15.9349 18.7344 15.6715 19.2032 15.2027C19.672 14.7339 19.9354 14.098 19.9354 13.4349V2.56494C19.9354 1.9019 19.672 1.26602 19.2032 0.797174C18.7344 0.328333 18.0985 0.0649414 17.4354 0.0649414ZM2.56543 1.06494H17.4354C17.8139 1.06409 18.1785 1.20727 18.4552 1.46542C18.7319 1.72357 18.9 2.07735 18.9254 2.45494C16.4554 3.77494 13.9754 5.08494 11.4954 6.40494C11.1605 6.61616 10.8054 6.79369 10.4354 6.93494C10.1453 6.99239 9.84634 6.98731 9.55836 6.92006C9.27039 6.85281 9.00007 6.72493 8.76543 6.54494C7.34543 5.79494 5.92543 5.03494 4.51543 4.28494C3.37543 3.68494 2.21543 3.07494 1.07543 2.46494C1.09839 2.08557 1.26545 1.72932 1.54243 1.46907C1.81941 1.20882 2.18537 1.06425 2.56543 1.06494ZM18.9354 13.4349C18.9354 13.8328 18.7774 14.2143 18.4961 14.4956C18.2148 14.7769 17.8333 14.9349 17.4354 14.9349H2.56543C2.1676 14.9349 1.78607 14.7769 1.50477 14.4956C1.22346 14.2143 1.06543 13.8328 1.06543 13.4349V3.59994C3.42543 4.83994 5.77543 6.09994 8.13543 7.34994C8.55696 7.60868 9.01091 7.81044 9.48543 7.94994C10.1798 8.06303 10.8915 7.91712 11.4854 7.53994C12.9354 6.77994 14.3754 6.00994 15.8254 5.24994C16.8654 4.68994 17.8954 4.14994 18.9354 3.59994V13.4349Z"
												fill="white" />
										</svg>

									</div>
									<div className="content">
										<Link href={`mailto:${contactInfo.email}`}>
											{ReactHtmlParser(contactInfo.email)}
										</Link>
									</div>
								</div>
							</div>
						)}

						<br /><br />
						<Social facebook={contactInfo?.facebook} youtube={contactInfo?.youtube} linkedin={contactInfo?.linkedin} instra={contactInfo?.instagram} />
					</Col>
					<Col md={asModal ? { span: 4, offset: 1 } : { span: 6, offset: 2 }}>
						<p className={'short_desc fade-up'}>{data?.section_data?.short_desc}</p>
						<FormContact
							asModal={asModal}
							career={career}
							interest={interest}
							data={formData}
							form_id={resolvedFormId}
							formData={resolvedFormData}
							id={resolvedFormId}
						/>
					</Col>
				</Row>
			</Container>
		</StyledContactForm>
	);
};


export default React.memo(ContactForm);
